import view from './view.html';

/* @ngInject */
export default function () {
	return {
		replace:                    true,
		template:                   view,
		scope:                      {
			element: '=',
		},
		controller: /* @ngInject */ ($scope, vcRecaptchaService) => {
			$scope.key = process.env.RECAPTCHA_KEY;

			$scope.response = null;
			$scope.widgetId = null;

			$scope.setResponse = function (response) {
				$scope.response = response;
			};

			$scope.setWidgetId = function (id) {
				$scope.widgetId = id;
			};

			$scope.cbExpiration = function () {
				toastr.clear();
				toastr.warning('Recaptcha Expired.', 'Error');
				vcRecaptchaService.reload($scope.widgetId);
				$scope.response = null;
			};
		},
		link:                       (scope, element, attrs) => {

		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/formElements/inputCaptcha/index.js